const FINN_PRICE = 779;

export {
  FINN_PRICE,
}
